/*
 * @Descripttion: 
 * @version: 
 * @Author: wanglongx
 * @Date: 2020-08-24 13:53:35
 * @LastEditors: bbqin
 * @LastEditTime: 2023-08-30 15:42:32
 */
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { GridFormItem, NormalFromItem } from './components/container/formItem';
import FormInfoGroup from './components/container/formInfoGroup';
import InfoGroupHeader from './components/icon/infoGroupHeader';
import { getPublicAttribute } from './utils/index';
import { PubSub, ViewModel, getTopWindow, throttle, microAppUtil } from '@platform/api';
import { WithAutoFocus, GridContainer } from '@platform/base';
import infoGroupIcon from './components/icon/infoGroupIcon';
const { FormWithAutoFocus } = WithAutoFocus;
let { getGlobalStorage } = ViewModel;

const Icons = infoGroupIcon.Icons;

// form变化,表格重新计算标识
const BEFOREFORMCOMPLETE = 'beforeAreaChangeComplete';
const FORMCOMPLETE = 'areaChangeComplete';
// 左右分栏展开收起变化,表格重新计算标识
const PUBLISHFORMRESIZE = 'dragWidthComExpand';

function debounce(fn, wait = 300) {
    let timer = null;
    return function (...rest) {
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        timer = setTimeout(() => {
            fn.apply(this, rest);
        }, wait);
    };
}

function getInfoGroupColor(icon = '') {
    // 获取颜色类型
    let color = 'orange';
    let tempKey = icon.split('pageMainIcon')[1] || '';
    Icons.find(item => {
        let key = item.src.split('pageMainIcon')[1] || '';
        key === tempKey && (color = item.color);
        return key === tempKey;
    });

    return color;
}

// 添加dom监控
function CreateResizeObserver(element, callback) {
    // let ResizeObserver = null;
    let ResizeObserver = window.ResizeObserver;
    let observer = null;
    if (ResizeObserver) {
        observer = new ResizeObserver(callback);
    } else {
        observer = new MutationObserver(callback);
        observer.unobserve = observer.disconnect;
        let observe = observer.observe;
        observer.observe = v => function () {
            observe(v, { subtree: true, childList: true });
        };
    }
    if (element) {
        observer.observe(element);
    }
    return observer;
}

// 创建单个form区域
@FormWithAutoFocus
class NormalForm extends Component {
    constructor(props) {
        super(props);
        this.state = { screen: 1920, layout: { width: 50, column: 2 } };
        this.isCalculated = false;
        this.calcTime = [];
        let fontClass = (window && window.nccFontSize) || (window && getTopWindow() && getTopWindow().nccFontSize) || getGlobalStorage('localStorage', 'nccFontSize') || '';
        switch (fontClass) {
            case 'large':
                this.boldFontSize = 'large';
                break;
            case 'medium':
                this.boldFontSize = 'medium';
                break;
            case 'small':
                this.boldFontSize = 'small';
                break;
            default:
                // this.boldFontSize = 'medium';
                break;
        }
        this.pubsubToken = [];
    }

    componentDidMount() {
        this.calcWidth();
        microAppUtil.addEventListener('visibilitychange', this.handleVisibilityChange);
        window.addEventListener('resize', this.handleResize);
        this.pubsubToken.push(PubSub.subscribe(PUBLISHFORMRESIZE, this.handleResize));
        const element = findDOMNode(this);
        this.resizeObserver = CreateResizeObserver(element, throttle(entries => {
            // ResizeObserverEntry mdn
            for (const entry of entries) {
                if (element === entry.target) {
                    if (entry.contentBoxSize && entry.contentBoxSize[0]?.inlineSize) {
                        let width = entry.contentBoxSize[0].inlineSize;
                        const screen = this.state.screen;
                        this.isCalculated = true;
                        switch (true) {
                            case width >= 1920:
                                width = 1920;
                                break;
                            case width >= 1440 && width <= 1919:
                                width = 1440;
                                break;
                            case width >= 1281 && width <= 1439:
                                width = 1366;
                                break;
                            case width >= 1025 && width <= 1280:
                                width = 1024;
                                break;
                            case width >= 600 && width <= 1024:
                                width = 600;
                                break;
                            case width < 600:
                                width = 599;
                                break;
                            default:
                                width = 1920;
                                break;
                        }

                        // 减少更新
                        if (screen !== width) {
                            this.setState({ screen: width });
                        }
                    }
                }
            }
        }, 17));
    }

    componentDidUpdate() {
        this.calcWidth();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
        microAppUtil.removeEventListener('visibilitychange', this.handleVisibilityChange);
        this.pubsubToken.forEach(token => {
            PubSub.unsubscribe(token);
        });
        this.pubsubToken = [];
        const element = findDOMNode(this);
        this.resizeObserver && this.resizeObserver.unobserve(element);
    }

    //YBP-CO-BUG-2123 页签激活的时候如果没算过，就在算一遍
    handleVisibilityChange = data => {
        if (data.visibilityState === 'visible') {
            this.calcWidth();
        }
    }

    handleResize = throttle(() => {
        let { prevWidth } = this.state;
        let width = findDOMNode(this)?.offsetWidth;
        // 列数需要根据组件宽度得到，而以下数值是UE给的分辨率
        // 组件宽度 + 32 = 分辨率
        // 加30缓冲区（如：滚动条）
        if (width) {
            this.isCalculated = true;
            width = width + 32 + 40;
            if (prevWidth !== width) {
                this.calcTime.push(new Date().getTime());
                let len = this.calcTime.length;
                if (len > 3 && this.calcTime[len - 1] - this.calcTime[len - 3] < 500) {
                    this.calcTime = [];
                    return;
                }

                PubSub.publishSync(BEFOREFORMCOMPLETE, true);
                //优化效率：默认是4列，宽度在4列范围内不再渲染
                let layout = { width: 50, column: 2 };

                if (width) {
                    let formItemWidth = 50;
                    let column = 2;
                    if (width < 600) {
                        formItemWidth = 100;
                        column = 1;
                    }
                    if (width >= 600 && width <= 1024) {
                        formItemWidth = 50;
                        column = 2;
                    }
                    if (width >= 1025 && width <= 1439) {
                        formItemWidth = 33.333333;
                        column = 3;
                    }
                    if (width >= 1440 && width <= 1919) {
                        formItemWidth = 25;
                        column = 4;
                    }
                    if (width >= 1920) {
                        formItemWidth = 20;
                        column = 5;
                    }
                    layout.width = formItemWidth;
                    layout.column = column;
                    this.setState({ layout });
                }
                this.setState({ prevWidth: width }, () => {
                    PubSub.publish(FORMCOMPLETE, true);
                });
            }
        }
    }, 17);

    calcWidth = () => {
        let { prevWidth } = this.state;
        let width = findDOMNode(this)?.offsetWidth;
        // 列数需要根据组件宽度得到，而以下数值是UE给的分辨率
        // 组件宽度 + 32 = 分辨率
        // 加30缓冲区（如：滚动条）
        if (width) {
            this.isCalculated = true;
            width = width + 32 + 40;
            if (prevWidth !== width) {
                this.calcTime.push(new Date().getTime());
                let len = this.calcTime.length;
                if (len > 3 && this.calcTime[len - 1] - this.calcTime[len - 3] < 500) {
                    this.calcTime = [];
                    return;
                }

                PubSub.publishSync(BEFOREFORMCOMPLETE, true);
                //优化效率：默认是4列，宽度在4列范围内不再渲染
                let layout = { width: 50, column: 2 };
                if (width) {
                    let formItemWidth = 50;
                    let column = 2;
                    if (width < 600) {
                        formItemWidth = 100;
                        column = 1;
                    }
                    if (width >= 600 && width <= 1024) {
                        formItemWidth = 50;
                        column = 2;
                    }
                    if (width >= 1025 && width <= 1439) {
                        formItemWidth = 33.333333;
                        column = 3;
                    }
                    if (width >= 1440 && width <= 1919) {
                        formItemWidth = 25;
                        column = 4;
                    }
                    if (width >= 1920) {
                        formItemWidth = 20;
                        column = 5;
                    }
                    layout.width = formItemWidth;
                    layout.column = column;
                    this.setState({ layout });
                }
                this.setState({ prevWidth: width }, () => {
                    PubSub.publish(FORMCOMPLETE, true);
                });
            }
        }
    }

    getInfoGroupItems = (info, items) => {
        let { form, list = [], name, fastToNext, getHotKeyConfig, formLayout, _runContext, limitItemHeight } = this.props;
        const { getStore } = form.getInnerHooks();
        formLayout = formLayout || getStore('formtopLayout');
        const { getFormItem, getLayout } = form.getInnerHooks();
        let status = form.getStatus();
        const { layout, screen } = this.state;
        const { name: infoName, icontype, langname = '' } = info;

        // 宽度计算
        let colTotalNum = 0;
        let leftSpaceCol = 0;
        let rightSpaceCol = 0;

        // 获取颜色类型
        let groupColor = getInfoGroupColor(icontype);

        const visibleItems = items.filter((itemCode, index) => {
            // 给信息组一个机会
            if (getFormItem(itemCode)['visible'] != true) {
                // 不进行普通渲染
                return false;
            }
            return itemCode;
        });

        let count = 0;

        return <div className={`form-info-group`}>
            <div className={`form-info-group-wrapper form-info-group-color color-${groupColor}`}>
                <InfoGroupHeader icon={icontype} color={groupColor} title={langname || infoName} />
                <div className="form-info-group-items-wrapper" >

                    <div className="form-info-group-items" >{visibleItems.map((itemCode, index) => {
                        let item = getFormItem(itemCode);
                        let publicAttr = getPublicAttribute(item, name, status);

                        let width = 50;
                        if (item.isnextrow || item.colnum == "5" || screen < 1280) {
                            width = 100;
                            count = 0; // 重新计数
                        }

                        let itemDom = <NormalFromItem
                            fontSize={this.boldFontSize}
                            {...item}
                            {...publicAttr}
                            className={`${publicAttr.className} ${count % 2 ? 'form-item-even' : 'form-item-odd'}`}
                            key={item.attrcode}
                            width={width}
                            leftSpaceCol={leftSpaceCol}
                            singleWidth={layout.width}
                            singleFormCode={name}
                            fastToNext={fastToNext}
                            formLayout={formLayout}
                            _runContext={_runContext}
                            limitItemHeight={limitItemHeight}
                        // 通過formContent 传递
                        // getHotKeyConfig={getHotKeyConfig}
                        />;

                        count++;

                        if (item.isnextrow || item.colnum == "5") {
                            count = 0; // 重新计数
                        }

                        return itemDom;
                    })}</div>
                </div>
            </div>
        </div>;
    };

    getInfoGroupDom = (currentFollow = [], target, nextFollow, prevFollow) => {
        let space = <div className="form-info-group-space"></div>;
        let beforeItems = [];
        let afterItems = [];
        let dom = [];
        currentFollow.forEach(info => {
            // let groupDom = [];
            let { items, direction, wordwrap, visible = true } = info;
            if (!visible) {
                // 不显示的不渲染
                return;
            }
            // 渲染信息组内的项
            if (direction === 'before') {
                // 换行
                wordwrap && beforeItems.push(space);
                beforeItems.push(this.getInfoGroupItems(info, items));
            } else {
                // 换行
                wordwrap && afterItems.push(space);
                afterItems.push(this.getInfoGroupItems(info, items));
            }
        });

        const prev = prevFollow ? null : space;
        const next = nextFollow ? null : space;

        if (beforeItems.length) {
            beforeItems = [prev, ...beforeItems, space];
        }

        if (afterItems.length) {
            afterItems = [space, ...afterItems, next];
        }

        dom = [...beforeItems, target, ...afterItems];
        return dom;
    };

    renderSingle = () => {
        let { form, list = [], name, fastToNext, getHotKeyConfig, formLayout, align, _runContext, limitItemHeight } = this.props;
        const { getStore, getFormItem, getLayout } = form.getInnerHooks();
        let infoGroup = getStore('infoGroup');
        formLayout = formLayout || getStore('formtopLayout');
        let status = form.getStatus();
        const { layout } = this.state;
        const currentInfoGroup = infoGroup && infoGroup.areaRelation[name];
        const currentFieldRelation = currentInfoGroup && currentInfoGroup.fieldRelation;
        // 宽度计算
        let colTotalNum = 0;
        let leftSpaceCol = 0;
        let rightSpaceCol = 0;

        // 过滤下数据  保证都是要显示的主数据
        list = list.filter(itemCode => {
            // 信息组内元素(字段关系)
            if (currentFieldRelation && currentFieldRelation[itemCode]) {
                // 不进行普通渲染
                return false;
            }
            // 给信息组一个机会
            if (getFormItem(itemCode)['visible'] != true) {
                // 不进行普通渲染
                return false;
            }

            return true;
        });

        return list.map((itemCode, index) => {
            let item = getFormItem(itemCode);
            let column = layout.column;
            let currentColNum = 1;
            if (item.colnum && Number(item.colnum) > 1) {
                if (item.colnum < column) {
                    currentColNum = Number(item.colnum);
                } else {
                    currentColNum = column;
                }
            }
            if (index === 0) {
                rightSpaceCol = column - currentColNum;
                colTotalNum = currentColNum;
            } else {
                leftSpaceCol = rightSpaceCol; //上个字段的右空白,用于折行控制
                colTotalNum = colTotalNum + currentColNum;
                // 如果当前字段有绑定信息组，并且是在后面，则换行
                let infoGroupArray = currentInfoGroup?.followRelation?.[itemCode] || [];
                item.isNextRow = infoGroupArray.some(item => item.direction === 'after');
                if (currentColNum > rightSpaceCol || item.isnextrow || item.isNextRow) {
                    //自动换行
                    if (item.isNextRow) {
                        colTotalNum = colTotalNum + column - currentColNum;
                        rightSpaceCol = 0;
                    } else {
                        colTotalNum = colTotalNum + rightSpaceCol;
                        rightSpaceCol = column - currentColNum;
                    }
                } else {
                    //继续放在当前行
                    let remain = colTotalNum % column;
                    rightSpaceCol = 0;
                    if (remain != 0) {
                        rightSpaceCol = column - remain;
                    }
                }
            }
            let width = currentColNum * layout.width;
            let publicAttr = getPublicAttribute(item, name, status);
            let itemDom = <NormalFromItem
                fontSize={this.boldFontSize}
                key={item.attrcode}
                leftSpaceCol={leftSpaceCol}
                singleWidth={layout.width}
                singleFormCode={name}
                fastToNext={fastToNext}
                {...item}
                width={width}
                {...publicAttr}
                formLayout={formLayout}
                align={align}
                _runContext={_runContext}
                limitItemHeight={limitItemHeight}
            // 通過formContent 传递
            // getHotKeyConfig={getHotKeyConfig}
            />;

            let currentFollow = currentInfoGroup && currentInfoGroup.followRelation[itemCode];
            // 信息组跟随关系
            if (currentFollow) {
                const nextItemCode = list[index + 1];
                const nextFollow = nextItemCode && currentInfoGroup && currentInfoGroup.followRelation[nextItemCode];
                const prevItemCode = list[index - 1];
                const prevFollow = prevItemCode && currentInfoGroup && currentInfoGroup.followRelation[prevItemCode];
                return this.getInfoGroupDom(currentFollow, itemDom, nextFollow, prevFollow);
            }
            return itemDom;
        });
    };

    render() {
        if (!this.isCalculated) {
            return <div className="form-blank"></div>;
        }
        let { className, align, formLayout, form } = this.props;
        const { getStore } = form.getInnerHooks();
        formLayout = formLayout || getStore('formtopLayout');
        let formAlignLeftClassName = align === 'left' ? 'light-app-form-align-left' : '';
        return (
            <div
                className={`group-form-item lightapp-component-form ${className} ${formAlignLeftClassName} ${formLayout === 'top' ? 'form-layout-top' : ''}`}
            >
                {this.renderSingle()}
            </div>
        );
    }
}

/**
 *  renderSingle根据layout渲染自由布局中的 FormItem || FormInfoGroup  
 *  FormInfoGroup --- FormItem
 *  FormItem---->renderGridFormItem------>Field
 *  FormItem---->renderNormalFromItem-------->Field
 * 
 * 需要把原来的Field抽一层共用的部分，用FormItem代替原来的Field的位置，
 * 根据不同的props去renderGridFormItem || renderNormalFromItem
 */

@FormWithAutoFocus
export class FreeLayoutForm extends Component {
    constructor(props) {
        super(props);
        this.boldFontSize = window.nccFontSize || getTopWindow().nccFontSize || getGlobalStorage('localStorage', 'nccFontSize') || '';
    }

    renderSingle = () => {
        let { form, list = [], name, fastToNext, formLayout, align, _runContext } = this.props;
        const { getFormItem, getStore } = form.getInnerHooks();
        formLayout = formLayout || getStore('formtopLayout');
        let status = form.getStatus();
        const loop = data => data.map(({ props }) => {
            let { itemCode, name: type, children = [] } = props;
            let item = getFormItem(itemCode) || {};
            let publicAttr = getPublicAttribute(item, name, status);
            if (type === 'FormInfoGroup') {
                const { iconType: groupIcon, title: groupTitle, langname = '' } = props;
                const groupColor = getInfoGroupColor(groupIcon);
                return <FormInfoGroup {...props} groupIcon={groupIcon} groupColor={groupColor} groupTitle={langname || groupTitle}> {loop(children)}</FormInfoGroup>;
            }
            return <GridFormItem
                fontSize={this.boldFontSize}
                key={item.attrcode}
                singleFormCode={name}
                fastToNext={fastToNext}
                {...item}
                {...publicAttr}
                {...props}
                formLayout={formLayout}
                align={align}
                _runContext={_runContext}
            />;
        });
        return loop(list);
    };
    render() {
        const { className, formArea = {}, align } = this.props;
        let { colGap, rowGap, moduleId } = formArea;
        let formAlignLeftClassName = align === 'left' ? 'light-app-form-align-left' : '';
        return (
            <GridContainer
                {...{ colGap, rowGap, moduleId }}
                className={`group-form-item lightapp-component-form ${className} ${formAlignLeftClassName}`}
            >
                {this.renderSingle()}
            </GridContainer>
        );
    }
}

export default NormalForm;
